import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_balance",
  "use": "icon-pnc_ic_balance-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_balance\"><path d=\"m12 23c-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11-4.9 11-11 11zm0-20c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z\" fill=\"#1a1a1a\" /><path clip-rule=\"evenodd\" d=\"m21 12c0 5-4 9-9 9-1.7 0-3.3-.5-4.7-1.3-.8-1.4-1.3-3-1.3-4.7 0-5 4-9 9-9 1.7 0 3.3.5 4.7 1.3.8 1.4 1.3 3 1.3 4.7z\" fill=\"#d1f0c5\" fill-rule=\"evenodd\" /><g fill=\"#1a1a1a\"><path d=\"m12 10.6c-.4 0-.8-.1-1.1-.4l-2.4-2.5c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.1 2.1 2.1-2.1c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-2.5 2.5c-.2.3-.6.4-1 .4z\" /><path d=\"m15 12h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m15 15h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z\" /><path d=\"m12 18c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1s1 .4 1 1v7c0 .6-.4 1-1 1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_balance.svg
// module id = rnxP
// module chunks = 87